import { motion } from "framer-motion";
import { Dumbbell, Users, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const features = [
  {
    icon: Dumbbell,
    title: "400m² Tilaa",
    desc: "Laaja valikoima laadukkaita kuntosalilaitteita ja vapaapainoja molemmilla saleilla.",
    link: "/kuntosalit",
    image: "/images/equipment.webp",
  },
  {
    icon: Users,
    title: "Personal Training",
    desc: "Yksilölliset valmennuspalvelut saliohjelmista pitkäaikaisiin valmennuksiin.",
    link: "/valmennus",
    image: "/images/personal-trainer.webp",
  },
  {
    icon: Clock,
    title: "Auki joka päivä",
    desc: "Jokela 24/7 ja Kellokoski 05:00–22:00. Treenaa silloin kun sinulle sopii.",
    link: "/aukiolot",
    image: "/images/open-hours.webp",
  },
];

export default function FeaturesSection() {
  return (
    <section className="section-padding bg-background">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="divider-primary mx-auto" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
            >
              <Link to={f.link} className="group block bg-card-premium rounded-lg overflow-hidden hover:border-primary/30 transition-all duration-300">
                <div className="h-48 overflow-hidden">
                  <img
                    src={f.image}
                    alt={f.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <f.icon className="text-primary mb-3" size={28} />
                  <h3 className="font-display text-xl font-semibold mb-2 text-foreground group-hover:text-primary transition-colors">
                    {f.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{f.desc}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
